<script>
	export let width;
	export let height;
	export let name;
	export let color;
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	{width}
	{height}
	viewBox="0 0 100 100"
	aria-labelledby={name}
	role="presentation"
	on:click
>
	<title id={name} lang="en">{`${name} icon`}</title>
	<g stroke={color} fill={color}>
		<slot />
	</g>
</svg>
